import {
  cacheKeyOf,
  getCachedUrl,
  pendingBatches,
  setCachedUrl,
  urlCache,
} from "./cache";
import { requestSignedUrls } from "./requestSignedUrls";
import type { GetProjectAssetUrls } from "./types";

export const getProjectAssetUrls: GetProjectAssetUrls = async ({
  projectId,
  keys,
}) => {
  const uniqueKeys = Array.from(new Set(keys));
  const missingKeys = uniqueKeys.filter((key) => {
    const cacheKey = cacheKeyOf(projectId, key);
    return !urlCache.has(cacheKey) && !pendingBatches.has(cacheKey);
  });

  if (missingKeys.length > 0) {
    const batch = requestSignedUrls(projectId, missingKeys);
    for (const key of missingKeys) {
      const cacheKey = cacheKeyOf(projectId, key);
      const perKey = batch.then((urls) => {
        const url = urls ? (urls[key] ?? null) : null;
        if (urls) {
          setCachedUrl(cacheKey, url);
        }
        pendingBatches.delete(cacheKey);
        return url;
      });
      pendingBatches.set(cacheKey, perKey);
    }
  }

  const entries = await Promise.all(
    uniqueKeys.map(async (key) => {
      const cacheKey = cacheKeyOf(projectId, key);
      const cached = getCachedUrl(cacheKey);
      if (cached !== undefined) return [key, cached] as const;

      const pending = pendingBatches.get(cacheKey);
      const url = pending ? await pending : null;
      return [key, url] as const;
    }),
  );

  return Object.fromEntries(entries);
};
